module.exports = __webpack_public_path__ + "media/images/paypal-logo-97a52c991984dcda94845fcb0dda125f.svg";